jQuery(document).ready(function ($) {
    const gallery_carousel = new Swiper('.rooms-carousel__rooms', {
        slidesPerView: 1,
        // Swipe in groups of 1
        slidesPerGroup: 1,

        spaceBetween: 24,

        slideClass: 'teaser',

        pagination: {
            el: '.rooms-carousel__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        speed: 500,

        grabCursor: true,

        breakpoints: {
            768: {
                slidesPerView: 2,
                // Swipe in groups of 2
                slidesPerGroup: 2,
            },
            1024: {
                slidesPerView: 3,
                // Swipe in groups of 3
                slidesPerGroup: 3,
            }
        }
    });
});